<template>
  <div :class="['lnner',{'hide':!show}]"
       id='imLinkUI'
       style=""
       ref='imLinkUI'>
    <div class="top">
      <div class="line"></div>
    </div>
    <div class="userImgBox">
      <img class='userImg'
           :src='this.imRoom.imLinkHead||defaultHead'
           alt=''>
    </div>
    <p class='fromText'><span class='userName'>{{imRoom&&imRoom.imLinkName}}</span>{{this.text}}</p>
    <div class="btnBox">
      <img class='left fl'
           :src='decline'
           alt=''
           @click.stop.prevent='unlisten'>
      <img class='right fr'
           ref='rightGo'
           :src='acepte'
           alt=''
           @click.stop.prevent='readMsg($event)'
           :data-href="`account=${this.imRoom.imLinkAccount}&scene=${this.imRoom.imLinkScene}&name=${this.imRoom.imLinkName}&roomid=${this.imRoom.RoomId}&userid=${this.imRoom.userId}&inviteid=${this.imRoom.inviteID}&mediaType=${this.imRoom.mediaType}`">
    </div>
  </div>
</template>

<script>
import decline from '../../assets/img/common/decline@3x.png' // 引入所需图片
import acepte from '../../assets/img/common/acepte@3x.png' // 引入所需图片
import defaultHead from '../../assets/img/common/default-icon1.png' // 引入所需图片
import { imUrlApi } from '@/api/imiframe.js'
import { langText, appUI } from "@/utils/imTools.js";
import { createNamespacedHelpers } from 'vuex'
import TIM from 'tim-js-sdk';
const namespace = 'imBus'
const { mapState, mapMutations } = createNamespacedHelpers(namespace)

export default {
  name: 'imLinkUI',
  data () {
    return {
      result: undefined,
      decline,
      acepte,
      defaultHead,
      text: undefined,
    }
  },
  computed: {
    ...mapState(['timjs', 'imLinkShow', 'imiframeApi', 'logined', 'imRoom']),
  },
  watch: {
    imLinkShow: {
      handler: function (val) {
        this.show = val
      },
      immediate: true
    },
    imRoom: {
      handler: function (val) {
        if (this.imRoom && this.imRoom.mediaType) {
          this.text = this.imRoom.mediaType == 1 ? langText('audioCallFor') : langText('videoCallFor')
          this.$refs.rightGo.dataset.href = `account=${this.imRoom.imLinkAccount}&scene=${this.imRoom.imLinkScene}&name=${this.imRoom.imLinkName}&roomid=${this.imRoom.RoomId}&userid=${this.imRoom.userId}&inviteid=${this.imRoom.inviteID}&mediatype=${this.imRoom.mediaType}`
        }
      },
      immediate: false
    },
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapMutations(['IMLINKSHOW_STATE', 'IMLINK_URL', 'IMLINK_URL_LOGINED']),
    init () {

    },
    readMsg (event) {
      if (this.logined) {
        let url = event.currentTarget.dataset.href
        this.IMLINKSHOW_STATE({ imLinkShow: false })
        let w = window.open(`${this.imiframeApi}?${url}`, 'view_window')
        w.resizeTo(500, 500)
        w.moveTo(200, 200)
      } else {
        this.imUrlCb()
      }
    },
    imUrlCb () {
      imUrlApi().then((res) => {
        let href = this.$refs.rightGo.dataset.href, judge = res.data.tmpUrl.indexOf('?'), url
        if (judge >= 0) {
          url = `${res.data.tmpUrl}&${href}`
        } else {
          url = `${res.data.tmpUrl}?${href}`
        }
        this.IMLINK_URL(res.data.imdomain)
        this.IMLINK_URL_LOGINED()
        this.IMLINKSHOW_STATE({ imLinkShow: false })
        let w = window.open(url, 'view_window')
        w.resizeTo(500, 500)
        w.moveTo(200, 200)
      })
    },
    unlisten () {
      if (this.imRoom.mediaType == 1) {
        this.SendCustomeMsg(`voiceCallReject`, 'audio-leave', this.imRoom.RoomId, null, this.imRoom.userId, this.imRoom.inviteID);
      } else {
        this.SendCustomeMsg(`videoCallReject`, 'video-leave', this.imRoom.RoomId, null, this.imRoom.userId, this.imRoom.inviteID);
      }
      this.IMLINKSHOW_STATE({ imLinkShow: false })
    },
    SendCustomeMsg (sendText, actionType = '', extension, members, inviter, inviterid) {
      let ext = extension, nowTime = new Date().getTime(), actionTypeNum, roomId, inviteeList = []
      if (actionType.indexOf('video') > -1) {
        if (sendText == 'videoCallReject') {
          let notice = {}, call_type = 2, call_end = undefined, busy = undefined
          actionTypeNum = 4
          roomId = ext
          inviteeList = [this.imRoom.imLinkAccount]
          let userId = ext
          notice[userId] = userId
        }
        for (let val in notice) {
          let msg = this.timjs.createCustomMessage({
            to: String(val),
            conversationType: TIM.TYPES.CONV_C2C,
            payload: {
              data: appUI.mediaSend(sendText, actionType, String(ext), actionTypeNum, inviter, roomId, call_type, busy, call_end, inviteeList, inviterid),
              description: actionType,
              extension: String(ext)
            }
          })
          this.sendMessage(msg, (res) => {
            console.log('------------video自定义消息成功');
          }, (err) => {
            throw err
          })
        }

      } else {
        let to, call_type = 1, call_end, busy
        if (sendText == 'voiceCallReject') {
          roomId = ext
          inviteeList = [this.imRoom.imLinkAccount]
          actionTypeNum = 4
          to = inviter
        }
        let msg = this.timjs.createCustomMessage({
          to: String(to),
          conversationType: TIM.TYPES.CONV_C2C,
          payload: {
            data: appUI.mediaSend(sendText, actionType, String(ext), actionTypeNum, inviter, roomId, call_type, busy, call_end, inviteeList, inviterid),
            description: actionType,
            extension: String(ext)
          }
        })
        this.sendMessage(msg, (res) => {
          console.log('------------audio自定义消息成功');
        }, (err) => {
          throw err
        })
      }
    },
    sendMessage (msg, cbOk, cbErr) {
      this.timjs.sendMessage(msg).then(res => {
        if (cbOk) return cbOk(res.data.message)
      }, () => {
        alert(langText('msgSendFail'))
        if (cbErr) cbErr()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.hide {
  display: none !important;
}
#imLinkUI {
  width: 375px;
  height: 215px;
  background: #2a3131;
  border-radius: 10px 10px 0 0;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999;
  padding: 0 20px;
  font-size: 0;
  .top {
    text-align: center;
    .line {
      width: 18px;
      height: 4px;
      border-radius: 4px;
      background: #a1a5a5;
      display: inline-block;
      margin-top: 8px;
    }
  }
  .userImgBox {
    text-align: center;
    .userImg {
      width: 45px;
      height: 45px;
      display: inline-block;
      margin: 17px 0;
      border-radius: 50%;
      padding: 7px;
      box-sizing: content-box;
      border: 1px solid rgba(255, 255, 255, 0.6);
    }
  }
  .fromText {
    margin-bottom: 18px;
    text-align: center;
    font-size: 14px;
    color: #cccccc;
  }
  .btnBox {
    img {
      width: 50px;
      height: 50px;
    }
    .left {
      margin-left: 30px;
      cursor: pointer;
    }
    .right {
      margin-right: 30px;
      cursor: pointer;
    }
  }
}
</style>